module.exports = __webpack_public_path__ + "static/media/register.3198bc44.png";